<template>
  <div class="thredd-login-logo">
    <img src="@/assets/img/thredd-logo-indigo.png" />
  </div>
</template>

<script setup lang="ts">
</script>

<style></style>
